<script setup lang="ts">
import { DropdownMenu } from "radix-vue/namespaced";
import { twMerge } from "tailwind-merge";

defineProps<{
  contentClassName?: string;
}>();
</script>

<template>
  <DropdownMenu.Root>
    <DropdownMenu.Trigger :asChild="true">
      <slot name="trigger" />
    </DropdownMenu.Trigger>

    <DropdownMenu.Portal>
      <DropdownMenu.Content
        :sideOffset="8"
        :class="[
          twMerge(
            'flex max-h-32 w-full max-w-xs min-w-40 flex-col overflow-y-auto rounded-lg bg-white py-1.5 shadow-lg',
            contentClassName,
          ),
        ]"
      >
        <slot name="content" />

        <DropdownMenu.Arrow class="fill-white" />
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  </DropdownMenu.Root>
</template>
